<template>
  <v-container fluid>
    <v-row align="center"
      justify="center"
      class="my-10">
      <h1>{{  `${roadId} ${roadName}` }} 停車格列表</h1>
    </v-row>
    <v-card>
        <v-card-title>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>
        <v-data-table
          :headers="headers"
          :items="parkingSpaces"
          :search="search"
          :sort-by="['code']"
          :items-per-page="10"
          class="elevation-1"
          @click:row="a"
        >
        <template v-slot:[`item.status`]="{ item }">
          <v-chip
            :color="getColor(item.status)"
          >
            {{ item.status}}
          </v-chip>
        </template>
        <template v-slot:[`item.delayMark`]="{ item }">
          <v-chip v-if="item.delayMark !== ''"
            color="orange">
            {{ item.delayMark }}
          </v-chip>
        </template>
        </v-data-table>
    </v-card>
  </v-container>

</template>

<script>
export default {
  created() {
    this.fetchData()
  },
  data() {
    return {
      search: '',
      roadId: this.$store.state.roadId,
      roadName: this.$store.state.roadName,
      roadFilters: this.$store.state.roadFilters,
      headers: [
        {
          text: '車格編號',
          align: 'start',
          sortable: true,
          value: 'code',
        },
        {
          text: '停車狀態',
          sortable: true,
          filterable: false,
          value: 'state',
        },
        {
          text: '車牌',
          value: 'license',
        },
        {
          text: '主機電量',
          sortable: true,
          value: 'systemPower',
        },
        {
          text: '雷達電量',
          sortable: true,
          value: 'radarPower',
        },
        {
          text: '設備狀態',
          sortable: true,
          filterable: true,
          value: 'status',
        },
        {
          text: '更新時間',
          align: 'start',
          sortable: true,
          filterable: false,
          value: 'updatedAt',
        },
        {
          text: '',
          sortable: true,
          filterable: true,
          value: 'delayMark',
        }
      ],
      parkingSpaces: [],
    }
  },
  methods: {
    fetchData() {
      this.parkingSpaces = [];
      this.axios.get(`api/parking_space?roadId=${this.roadId}`).then((resp) => {
        resp.data.forEach(ps => {
          if (this.roadFilters.length > 0 && !this.roadFilters.includes(ps.id)) {
            return;
          }

          const parkingSpace = {
            id: ps.id,
            code: ps.road_code ? ps.code : ps.id,
            state: ps.park_status != null ? ps.park_status ? "滿位" : "空位" : "",
            license: ps.car_id,
            systemPower: ps.system_power,
            radarPower: ps.radar_power,
            status: "",
            updatedAt: this.$moment(ps.updated_at).format('YYYY-MM-DD HH:mm:ss'),
            delayMark:  "",
          }

          if (ps.deleted_at) {
            parkingSpace.status = "Deleted";
          } else if(ps.last_record_time) {
            if (this.$moment().diff(this.$moment(ps.updated_at), 'hours') < 3) {
              parkingSpace.status = "On";

              if (this.$moment().diff(this.$moment(ps.last_record_time), 'hours') > 0 ) {
                parkingSpace.delayMark = "!";
              }
            } else {
              parkingSpace.status = "Off";
            }
          }

          this.parkingSpaces.push(parkingSpace)
        });
      })
    },
    getColor(status) {
      if (status === 'Deleted') return 'gray'
      else if (status === 'Off') return 'red'
      else if (status === 'On') return 'green'
      else return ''
    },
    a(data) {
      this.$store.commit("SetPS", data);
      let routeData = this.$router.resolve({ name: 'ps', query: { id: data.id, code: data.code || data.id } });
      window.open(routeData.href, '_blank');
    }
  }
}
</script>
